import type { ReactNode } from 'react';

type P = {
  left: ReactNode;
  right: ReactNode;
};

const StatusBarLayout = ({ left, right }: P) => (
  <div className="footer-status-bar">
    <div className="footer-status-bar--left">{left}</div>
    <div className="footer-status-bar--right">{right}</div>
  </div>
);

export default StatusBarLayout;
